import { z } from "zod";

/**
 * Single source of truth for material image limits (BEL-850). The API
 * validates uploaded objects against it; the webapp reads it to size and
 * compress the two WebP versions. No other file may repeat these numbers.
 */
export const MATERIAL_IMAGE_BUDGETS = {
  thumbnail: { maxSidePx: 160, maxBytes: 20_480 },
  full: { maxSidePx: 1200, maxBytes: 204_800 },
} as const;

export const MaterialImageVersion = z.enum(["thumbnail", "full"]);
export type MaterialImageVersion = z.infer<typeof MaterialImageVersion>;

export const MATERIAL_IMAGE_INVALID_CODE = "MATERIAL_IMAGE_INVALID";

/** Why one image version was rejected. Stable: clients may switch on it. */
export const MaterialImageRejection = z.enum([
  "NOT_FOUND", // missing, or belongs to another customer (indistinguishable on purpose)
  "NOT_WEBP",
  "OVER_BUDGET",
  "STORAGE_UNREADABLE",
  "PAIR_REQUIRED", // only one of the two versions was sent
  "DUPLICATE_VERSION", // thumbnail and full point at the same attachment
]);
export type MaterialImageRejection = z.infer<typeof MaterialImageRejection>;

/** Both ids together or neither; `null` on both removes the image. */
export const MaterialImageInputFields = z.object({
  imageAttachmentId: z.string().uuid().nullable().optional(),
  imageThumbnailAttachmentId: z.string().uuid().nullable().optional(),
});

export const MaterialImageDtoFields = z.object({
  imageAttachmentId: z.string().uuid().nullable().optional(),
  imageThumbnailAttachmentId: z.string().uuid().nullable().optional(),
  imageUrl: z.string().nullable().optional(),
  imageThumbnailUrl: z.string().nullable().optional(),
});
